import { CustomListItemId } from "@sp-crm/core";
import { CustomListMultiselect } from "components/shared/custom-list-multiselect";
import { produce } from "immer";
import React from "react";
import {
    customListKeyForEntityType,
    entityTypeStatusFilterLabel,
    findClientStatusFieldMatcher,
} from "./manage-workflows-helper";
import { EditableWorkflow } from "./types";

interface ClientStatusTriggerEditorProps {
    workflow: EditableWorkflow;
    onChange: (newWorkflow: EditableWorkflow) => void;
}

export const ClientStatusTriggerEditor: React.FC<
    ClientStatusTriggerEditorProps
> = props => {
    const { workflow, onChange } = props;

    const handleChange = (selectedIds: CustomListItemId[]) => {
        const newWorkflow = produce(workflow, draft => {
            const matcher = findClientStatusFieldMatcher(draft);

            if (matcher) {
                matcher.fieldName = "statusListItem";
                matcher.current.values = selectedIds;
            }
        });

        onChange(newWorkflow);
    };

    const fieldMatcher = findClientStatusFieldMatcher(workflow);

    if (!fieldMatcher) {
        return null;
    }

    return (
        <div>
            <p>{entityTypeStatusFilterLabel(workflow.attachTo)}</p>
            <CustomListMultiselect
                disabled={!workflow.regionVisibility?.editable}
                customListKey={customListKeyForEntityType(workflow.attachTo)}
                value={fieldMatcher.current.values || []}
                onChange={handleChange}
            />
        </div>
    );
};
